import { useIntl } from 'react-intl';

import { FormControl, FormControlStack, FormField, FormItem, FormLabel, FormMessage } from 'src/registry/ui/Form';
import { Input } from 'src/registry/ui/Input';

import type { ControllerRenderProps, FieldValues, Path, UseFormReturn } from 'react-hook-form';

interface FormFieldInputTextProps<T extends FieldValues> {
    form: UseFormReturn<T>;
    name: Path<T>;
    label: { id: string; defaultMessage: string };
    isRequired?: boolean;
}

export function FormFieldInputText<T extends FieldValues>({
    form,
    name,
    label,
    isRequired = false,
}: FormFieldInputTextProps<T>) {
    const { formatMessage } = useIntl();

    return (
        <FormField
            control={form.control}
            name={name}
            render={({ field }: { field: ControllerRenderProps<T, Path<T>> }) => (
                <FormItem variant="dialog">
                    <FormLabel variant="dialog" required={isRequired}>
                        {formatMessage(label)}
                    </FormLabel>
                    <FormControlStack>
                        <FormControl>
                            <Input
                                type="text"
                                placeholder={formatMessage(label)}
                                value={String(field.value ?? '')}
                                onChange={field.onChange}
                            />
                        </FormControl>
                        <FormMessage />
                    </FormControlStack>
                </FormItem>
            )}
        />
    );
}
